/**
 * Admin-only entry to read the product as a student.
 * Shown on the speaker list and the account list.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { Button, useToast } from "@xinghai/ui";
import { usersApi } from "../../lib/api";
import { friendlyMessage } from "../../lib/apiErrors";
import { useAuth } from "../auth/useAuth";

export function ViewAsStudentButton({
  userId,
  disabled = false,
}: {
  userId: string | null | undefined;
  disabled?: boolean;
}) {
  const { roles } = useAuth();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const toast = useToast();
  const start = useMutation({
    mutationFn: () => usersApi.viewAs(userId!),
    onSuccess: async () => {
      await qc.invalidateQueries();
      navigate("/s");
    },
    onError: (err) => toast.error(friendlyMessage(err, "没能进入学生视角。")),
  });
  if (!roles.includes("admin") || !userId || disabled) return null;
  return (
    <Button
      size="sm"
      variant="secondary"
      loading={start.isPending}
      onClick={() => start.mutate()}
    >
      以学生身份查看
    </Button>
  );
}
